import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { PartCard } from "#modules/similarPart/view/PartCard";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

export const SidePartCard = ({
  sourceQuoteRequestLine,
  FooterComponent,
  onSubmitPartDimensions,
  index,
}: {
  sourceQuoteRequestLine: QuoteRequestLineDto | undefined | null;
  onSubmitPartDimensions?: () => void;
  FooterComponent?: React.FC;
  index?: number;
}) => {
  if (!sourceQuoteRequestLine || !sourceQuoteRequestLine.quantity) {
    return null;
  }

  return (
    <Stack
      pr="md"
      style={{
        borderRightWidth: 1,
        borderColor: colors.gray[2],
        borderRightStyle: "solid",
        width: 400,
      }}
      gap="xxs"
    >
      <Text fz="h1" fw={600}>
        {t("clustering.sidePartCard.title")}
      </Text>

      <PartCard
        quoteRequestLineMaterialGrade={sourceQuoteRequestLine.materialGrade}
        part={sourceQuoteRequestLine.part}
        quantity={sourceQuoteRequestLine.quantity}
        quoteRequestLine={sourceQuoteRequestLine}
        onSubmitPartDimensions={onSubmitPartDimensions}
        dimensionsUpdatable={true}
        index={index || 0}
      />

      {FooterComponent && <FooterComponent />}
    </Stack>
  );
};
